module.exports = __webpack_public_path__ + "img/takeout.cdebaa1a.svg";